import { mapActions, mapState } from 'vuex';
import { get } from 'lodash';

import loaderMixin from '@/mixins/loader';

export default {
  mixins: [
    loaderMixin,
  ],
  props: {
    obj: Object,
    category: String,
    disabled: Boolean,
  },
  data() {
    return {
      modelValue: null,
      oldValue: null,
    };
  },
  computed: {
    ...mapState('profile', ['settings']),
    classObject() {
      return {
        'settings-option-switch': true,
        'settings-option-switch--disabled': this.disabled,
      };
    },
    isDisabled() {
      return this.disabled;
    },
  },
  methods: {
    ...mapActions('profile', ['updateSettings']),
    isOptionDisabled(option) {
      return this.isDisabled || !!option.disabled;
    },
    change(value) {
      this.loaderAddLegacy();
      this.modelValue = value;
      this.updateSettings({
        category: this.category,
        key: this.obj.key,
        value,
      })
      .then(() => {
        this.oldValue = this.modelValue;
        this.loaderRemoveLegacy();
      })
      .catch(() => {
        this.loaderRemoveLegacy();
        this.modelValue = this.oldValue;
        this.$emit('error', `Could not set "${this.obj.info}"`);
      });
      this.$emit('change', value);
    },
  },
  created() {
    const value = get(this.settings, [this.category, this.obj.key]);
    this.modelValue = value !== undefined ? value : this.obj.defaultValue;
    this.oldValue = this.modelValue;
  },
};



// WEBPACK FOOTER //
// ./src/components/account/settings/settings-option-switch/settings-option-switch.js